import { X } from "lucide-react";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { EVENT_KIND_LABELS } from "./scheduleConstants";
import { ScheduleEventDetail } from "./ScheduleEventDetail";
import type { ScheduleEvent } from "@/types/schedule";

interface ScheduleEventDetailDialogProps {
  event: ScheduleEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Modal detail pane for a booking milestone event (Kai schedule card + schedule page). */
export function ScheduleEventDetailDialog({
  event,
  open,
  onOpenChange,
}: ScheduleEventDetailDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="glass-overlay flex max-h-[min(85dvh,var(--app-vvh,85vh))] flex-col overflow-hidden rounded-2xl border-border/60 p-0 shadow-2xl sm:max-w-md"
        aria-describedby={undefined}
      >
        <div className="flex shrink-0 items-start gap-3 border-b border-border/50 px-5 py-4">
          <DialogHeader className="min-w-0 flex-1 space-y-1 text-left">
            <DialogTitle className="text-base font-semibold leading-tight">
              {event ? EVENT_KIND_LABELS[event.kind] : "Booking milestone"}
            </DialogTitle>
            {event && (
              <DialogDescription className="line-clamp-2 text-sm text-muted-foreground">
                {event.title}
                {event.time ? ` · ${event.time}` : ""}
              </DialogDescription>
            )}
          </DialogHeader>
          <DialogClose
            className="rounded-md p-1 text-muted-foreground transition-colors hover:bg-foreground/10 hover:text-foreground"
            aria-label="Close"
          >
            <X className="size-4" />
          </DialogClose>
        </div>
        <ScheduleEventDetail event={event} embedded />
      </DialogContent>
    </Dialog>
  );
}
